import React from 'react';
import LoginLink from 'core/modules/LoginLink/LoginLink';

import './SignInNagSmall.scss';

function SignInNagSmall({ handleTermsClick }) {
  return (
    <div className="mn_signInNagSmall">
      <div className="mn_innerWrap">
        <div className="mn_nagDescription">
          <h3>Earn up to 1,000 bonus miles as a new shopper. </h3>
          <button className="mn_termsButton" onClick={handleTermsClick}>Learn more</button>
        </div>
        <div className="mn_nagControl">
          <LoginLink className="mn_button mn_secondaryButton" isource="small mobile nag">
            Sign in
          </LoginLink>
        </div>
      </div>
    </div>
  );
}

export default SignInNagSmall;
